module.exports = __webpack_public_path__ + "img/brand_activity.86149569.png";